import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';
import { SaveMessageComponent } from '../directive/save-message/save-message.component';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-corporate',
  templateUrl: './corporate.component.html',
  styleUrls: ['./corporate.component.css']
})
export class CorporateComponent implements OnInit {
  subs = new Subscription();

  constructor(private dialog: MatDialog,
    private afs: AngularFirestore, private http: Http, private router: Router, @Inject(DOCUMENT) private document: Document) { }

  getIpAdress(): Observable<any> {
    return this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => data.json());
  }

  joinUs(email) {
    if (email.replace(/\s/g, '') == '') {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "E-posta adresini yazmalısın!",
          type: "update"
        }
      });
      return;
    }
    this.subs = this.getIpAdress().subscribe(data => {
      this.afs.collection('newsLetter').add({
        email: email,
        modifyDate: Date.now(),
        ipAdress: data
      }).then(() => {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Bilgilerin iletilmiştir, teşekkürler.",
            type: "update"
          }
        });
      });
    });

  }

  navigate() {
    this.router.navigate(['/corporate/faq']);
    this.document.documentElement.scrollTop = 0;
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/corporate/corporate.component.ts